module.exports = __webpack_public_path__ + "static/media/hexagon.b3224c56.svg";